/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { form as FormStyle } from '../../../style/form';
import { deepObjectExtend } from '../../../utils/object';
import { combineStyle } from '../../../style/combineStyle';
import { DesktopTrackOrderStyle } from '../../../style/DesktopTrackOrderStyle';
import TrackOrderByZipCode from '../TrackOrderByZipCode';
import DesktopDeliveryHours from './DesktopDeliveryHours';
import GraphqlSeoHeadTags from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        FormStyle,
        DesktopTrackOrderStyle,
    }),
);

const DesktopTrackOrder = ({ classes, brand }) => {
    /* eslint-disable max-len */
    const brandDisplayName = brand?.['display-name'] || brand?.['description'];
    const seo = {
        page_title: `Order Tracking to Track Your ${brandDisplayName} Order | ${brandDisplayName}`,
        meta_description: `Easily track your ${brandDisplayName} order by signing in to your account, or by inputting your order number. Delivery hours based on recipient's time zone: Residential: 9am-8pm & Business: 9am-6pm.`,
        location: { pathname: '/account/orders' },
    };

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <h1 className={classes.trackOrderHeader}><span>Guest Order Tracking</span></h1>
            <div className={classes.DesktopTrackOrderStyle}>
                <DesktopDeliveryHours classes={classes} />
                <TrackOrderByZipCode />
            </div>
        </>
    );
};

DesktopTrackOrder.propTypes = {
    classes: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
};

export default (withStyles(styles)(DesktopTrackOrder));
